/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { grayColor, primaryColor } from "../../material-dashboard-pro-react";
import { blackColor, cardTitle, hexToRgb } from "../../material-dashboard-pro-react.jsx";
import customSelectStyle from "../customSelectStyle.tsx";
import customCheckboxRadioSwitch from "../../material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import dashboardStyle from "./dashboardStyle";
import customTableStyle from "../customTableStyle";

const extendedFormsStyle = {
  ...customCheckboxRadioSwitch,
  ...customSelectStyle,
  ...dashboardStyle,
  ...customTableStyle,
  selectFormControl: {
    margin: "0px 0 17px 0 !important",
    "& > div": {
      "&:before": {
        borderBottomWidth: "1px !important",
        borderBottomColor: grayColor[4] + "!important",
      },
      "&:after": {
        borderBottomColor: primaryColor[0] + "!important",
      },
    },
  },
  cardTitle: {
    ...cardTitle,
    fontSize: "2.5rem",
    margin: "0px 3px",
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  label: {
    cursor: "pointer",
    paddingLeft: "0",
    color: "rgba(" + hexToRgb(blackColor) + ", 0.26)",
    fontSize: "14px",
    lineHeight: "1.428571429",
    textAlign: "right",
    fontWeight: "400",
    display: "inline-flex",
  },
  mrAuto: {
    marginRight: "auto",
  },
  mlAuto: {
    marginLeft: "auto",
  },
  totalRow: {
    backgroundColor: "#ff9800",
  },
  optionRow: {
    backgroundColor: "#f9f8f7",
  },
};

export default extendedFormsStyle;
